enum InvestmentCodeTypeEnum {
    Legacy = 'LAI',
    New = 'FI',
}

export default InvestmentCodeTypeEnum;
